import React from 'react';
import { Button, createMuiTheme, ThemeProvider } from '@material-ui/core';

interface IColorButton {
  color: string;
  darkColor?: string;
  onClick?: () => {} | void;
  title?: string;
  disable?: boolean;
  disabledStyle?: React.CSSProperties;
}

const ColorButton: React.FC<IColorButton> = ({ children, color, onClick, disable, disabledStyle }) => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: color,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Button
        onClick={onClick}
        color="primary"
        variant="contained"
        disableElevation
        disabled={disable}
        style={disable ? disabledStyle : undefined}
      >
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default ColorButton;
